import {
  HomeIcon,
  BookmarksIcon,
  ExploreIcon,
  NotificationsIcon,
  PeopleIcon,
} from "icons";

const navLinks = [
  ["Home", "/home", HomeIcon],
  ["Explore", "/explore", ExploreIcon],
  ["Bookmarks", "/bookmarks", BookmarksIcon],
  ["Notifications", "/notifications", NotificationsIcon],
  ["People", "/people", PeopleIcon],
];

export { navLinks };
